export function initScreenUnit() {
  let element = document.documentElement;
  element.style.fontSize = element.clientWidth / 3.75 + 'px';
}
